document.addEventListener('DOMContentLoaded', () => {
      if (typeof Fancybox !== 'undefined' && document.querySelector('[data-fancybox="gallery"]')) {
        Fancybox.bind('[data-fancybox="gallery"]', {
          Hash: false,
          Thumbs: false,
          compact: false,
          contentClick: "toggleCover",
          wheel: "slide",
          showClass: "f-zoomInRight",
          hideClass: "f-zoomOutLeft",
          Toolbar: false,
          Images: {
            Panzoom: {
              panMode: "mousemove",
              mouseMoveFactor: 1.1,
              mouseMoveFriction: 0.12,
            },
          },
          on: {
            ready: (fancybox) => {
              document.querySelector('.fancybox-controls')?.remove();
              const controls = document.createElement('div');
              controls.className = 'fancybox-controls';
              controls.innerHTML = `
                <button class="fancy-prev navBtn" title="Previous">
                  <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 18">
                    <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path>
                  </svg>
                </button>
                <button class="fancy-close" title="Close">
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path d="M6 6L18 18M6 18L18 6"></path>
                  </svg>
                </button>
                <button class="fancy-next navBtn" title="Next">
                  <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 18">
                      <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
                  </svg>
                </button>
              `;
              fancybox.container.appendChild(controls);
              controls.querySelector('.fancy-close').addEventListener('click', () => fancybox.close());
              controls.querySelector('.fancy-next').addEventListener('click', () => fancybox.next());
              controls.querySelector('.fancy-prev').addEventListener('click', () => fancybox.prev());
            },
            destroy: () => {
              document.querySelector('.fancybox-controls')?.remove();
            },
          },
        });
      }
    });
